import "./footer.css";
export default function Footer() {
  return <footer>Commed Kft © V1.0.0</footer>;
}
